module.exports = __webpack_public_path__ + "static/media/O.1c891fe5.svg";